// extracted by mini-css-extract-plugin
module.exports = {"container":"cq","image":"cr","imageLink":"cs","content":"ct","title":"cu","link":"cv","itemWithIcon":"cw","text":"cx","linkTitle":"cy","description":"cz","button":"cA"};